import api from '@motionelements/core/src/api/base-api-v2';
// import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';

const baseUrl = '/v2/artist/creators';

export const listCreators = async (params, axiosConfig) => {
  params = params || {};

  const config = {
    params: {
      ...api.getLocaleParams(),
      ...(params || {}),
    },
    ...(axiosConfig || {}),
  };

  return api.request('get', baseUrl, config);
};

export const createCreator = data => api.request('post', baseUrl, { data });

export const updateCreator = (id, data) => api.request('patch', `${baseUrl}/${id}`, { data });

export const deleteCreator = id => api.request('delete', `${baseUrl}/${id}`);

